// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27%3E%3Cpath d=%27M1 1l4 4 4-4%27 fill=%27none%27 stroke=%27%23a29b8d%27 stroke-width=%271.5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Users (redesign) — /users inside a business and /overview/users for the
   whole group. Scoped under .us-page. Colours are written out rather than
   taken from --rf-* so the same sheet renders identically inside the
   AppShell (.rf-app) and on the standalone overview chrome (.overview-page). */

.us-page {
  flex-grow: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  /* .rf-content doesn't cap height — bound to the viewport minus the top
     bar (64px) and the .rf-app gutter + border, so the table scrolls
     internally and the toolbar stays put. */
  height: calc(100vh - 76px);
  font-family: "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  -webkit-font-smoothing: antialiased;
}
.us-page.is-standalone {
  /* Under the 68px overview top bar instead. */
  height: calc(100vh - 68px);
}
.us-page *,
.us-page *::before,
.us-page *::after {
  box-sizing: border-box;
  transition: none;
}
.us-serif {
  font-family: "Instrument Serif", Georgia, serif;
  font-weight: 400;
}
.us-num {
  font-variant-numeric: tabular-nums;
}

/* ---------------- header + toolbar ---------------- */
.us-head {
  padding: 22px 28px 0;
  display: flex;
  align-items: flex-end;
  gap: 18px;
  flex-shrink: 0;
  /* App.css styles bare <header> globally — reset it */
  margin: 0;
  text-align: left;
  font-weight: normal;
}
.us-head-text {
  min-width: 0;
  flex-grow: 1;
}
.us-title {
  font-size: 24px;
  line-height: 1.15;
  margin: 0;
  color: #191714;
}
.us-lede {
  font-size: 13px;
  color: #6f6a60;
  margin: 4px 0 0;
}
.us-toolbar {
  padding: 16px 28px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  flex-wrap: wrap;
}
.us-search {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 12px;
  border: 1px solid #e7e3da;
  border-radius: 8px;
  background: #fdfcfa;
  min-width: 250px;
  cursor: text;
}
.us-search:focus-within {
  border-color: var(--rf-brand-lite);
}
.us-search-icon {
  width: 13px;
  height: 13px;
  border: 1.5px solid #a29b8d;
  border-radius: 50%;
  display: block;
  flex-shrink: 0;
}
.us-search input {
  border: none;
  background: none;
  outline: none;
  font: 400 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  width: 100%;
}
.us-search input::placeholder {
  color: #a29b8d;
}
.us-segmented {
  display: flex;
  gap: 2px;
  background: #eae6dd;
  padding: 3px;
  border-radius: 9px;
}
.us-segmented button {
  border: none;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 7px;
  font: 600 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  background: transparent;
  color: #7c766a;
  white-space: nowrap;
}
.us-segmented button.is-active {
  background: #fff;
  color: #191714;
  box-shadow: 0 1px 3px rgba(40, 34, 22, 0.14);
}
.us-select {
  height: 34px;
  padding: 0 32px 0 11px;
  border: 1px solid #e7e3da;
  border-radius: 8px;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 11px center;
  font: 500 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #4a453c;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  outline: none;
}
.us-select:focus {
  border-color: var(--rf-brand-lite);
}
.us-spacer {
  flex-grow: 1;
}
.us-btn {
  cursor: pointer;
  height: 34px;
  border-radius: 8px;
  font: 600 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  white-space: nowrap;
}
.us-btn:disabled {
  opacity: 0.5;
  cursor: default;
}
.us-btn-ghost {
  padding: 0 14px;
  border: 1px solid #e7e3da;
  background: #fff;
  color: #4a453c;
}
.us-btn-ghost:hover:not(:disabled) {
  background: #f6f4ef;
}
.us-btn-primary {
  padding: 0 16px;
  border: none;
  background: var(--rf-brand);
  color: #fff;
}
.us-btn-primary:hover:not(:disabled) {
  background: var(--rf-brand-hover);
}
.us-btn-danger {
  padding: 0 14px;
  border: 1px solid #e9cfcb;
  background: #fff;
  color: #a8483e;
}
.us-btn-danger:hover:not(:disabled) {
  background: #fbefed;
}
.us-link {
  background: none;
  border: none;
  padding: 0;
  font: 600 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--rf-brand);
  cursor: pointer;
  white-space: nowrap;
}
.us-link:hover {
  color: var(--rf-brand-lite);
}
.us-count {
  font-size: 12.5px;
  color: #8b8477;
  white-space: nowrap;
}

/* ---------------- table ---------------- */
.us-tablewrap {
  flex-grow: 1;
  min-height: 0;
  padding: 0 28px 22px;
  display: flex;
}
.us-table {
  flex-grow: 1;
  min-width: 0;
  background: #fff;
  border: 1px solid #e7e3da;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.us-thead {
  display: flex;
  align-items: center;
  height: 38px;
  padding: 0 18px;
  background: #faf8f3;
  border-bottom: 1px solid #e7e3da;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #8b8477;
  flex-shrink: 0;
}
.us-tbody {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
}
.us-row {
  display: flex;
  align-items: center;
  min-height: 60px;
  padding: 10px 18px;
  border-bottom: 1px solid #f0ece3;
  background: #fff;
  cursor: pointer;
  width: 100%;
  border-left: none;
  border-right: none;
  border-top: none;
  text-align: left;
  font-family: inherit;
  color: inherit;
}
.us-row:hover {
  background: #fdfcfa;
}
.us-row.is-self {
  background: #fbf9f5;
}
.us-group:last-child .us-row:last-child {
  border-bottom: none;
}

/* group header: one per role, sticks while its rows scroll */
.us-group-head {
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 18px;
  background: #f6f4ef;
  border-bottom: 1px solid #e7e3da;
  font-size: 12.5px;
  font-weight: 600;
  color: #4a453c;
}
.us-group-head i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  display: block;
}
.us-group-head.role-owner i {
  color: var(--rf-brand);
}
.us-group-head.role-admin i {
  color: var(--rf-accent);
}
.us-group-head.role-staff i {
  color: #7a5b7d;
}
.us-group-head.role-driver i {
  color: #6b6f3f;
}
.us-group-count {
  font-size: 11.5px;
  font-weight: 600;
  color: #8b8477;
  background: #fff;
  border: 1px solid #e7e3da;
  border-radius: 20px;
  padding: 1px 8px;
}

.us-col-person {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding-right: 16px;
}
.us-col-biz {
  width: 250px;
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding-right: 16px;
}
.us-col-role {
  width: 150px;
  flex-shrink: 0;
  padding-right: 12px;
}
.us-col-date {
  width: 110px;
  flex-shrink: 0;
}
.us-row .us-col-date {
  font-size: 12.5px;
  color: #6f6a60;
}
.us-col-actions {
  width: 120px;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.us-col-actions .us-btn {
  height: 30px;
  padding: 0 11px;
  font-size: 12px;
}

.us-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.02em;
  overflow: hidden;
}
.us-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.us-avatar.is-lg {
  width: 48px;
  height: 48px;
  font-size: 16px;
}
.us-person {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.us-person-name {
  font-size: 14px;
  font-weight: 600;
  color: #191714;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.us-person-sub {
  font-size: 12px;
  color: #8b8477;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.us-person-email {
  margin-left: 8px;
  padding-left: 8px;
  border-left: 1px solid #ddd7cb;
}

.us-you {
  display: inline-block;
  margin-left: 6px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--rf-brand);
  background: var(--rf-brand-tint);
  padding: 1px 6px;
  border-radius: 20px;
  vertical-align: 1px;
}

/* role pill: the four roles each get a tone */
.us-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 0 9px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  background: #f6f4ef;
  color: #4a453c;
}
.us-pill i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  display: block;
}
.us-pill.role-owner {
  background: var(--rf-brand-tint);
  color: var(--rf-brand);
}
.us-pill.role-admin {
  background: #e9f0ef;
  color: var(--rf-accent);
}
.us-pill.role-staff {
  background: #f1eef2;
  color: #7a5b7d;
}
.us-pill.role-driver {
  background: #eeefe3;
  color: #6b6f3f;
}
.us-pill.is-readonly {
  opacity: 0.7;
}
.us-pill-code {
  font-weight: 700;
  letter-spacing: 0.04em;
}
.us-pill-sep {
  opacity: 0.5;
}

.us-inactive {
  display: inline-block;
  margin-left: 6px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #a8483e;
  background: #f7ebe9;
  padding: 1px 6px;
  border-radius: 20px;
}

/* empty / error / loading */
.us-empty {
  padding: 48px 0;
  text-align: center;
  color: #a29b8d;
  font-size: 13px;
}
.us-empty b {
  display: block;
  font-family: "Instrument Serif", Georgia, serif;
  font-weight: 400;
  font-size: 20px;
  color: #191714;
  margin-bottom: 6px;
}
.us-error {
  margin: 0 28px 22px;
  background: #fbf9f5;
  border: 1px solid #eee9df;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 13px;
  color: #4a453c;
}
.us-error b {
  font-weight: 600;
  color: #191714;
}
.us-skel {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 60px;
  padding: 10px 18px;
  border-bottom: 1px solid #f0ece3;
}
.us-skel i {
  display: block;
  height: 12px;
  border-radius: 6px;
  background: #f0ece3;
}
.us-skel .us-skel-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

/* ---------------- editor modal (centred) ---------------- */
.us-drawer-wrap {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-family: "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.us-drawer-wrap *,
.us-drawer-wrap *::before,
.us-drawer-wrap *::after {
  box-sizing: border-box;
  transition: none;
}
.us-scrim {
  position: absolute;
  inset: 0;
  background: rgba(25, 23, 20, 0.36);
}
.us-drawer {
  position: relative;
  width: 620px;
  max-width: 100%;
  max-height: 100%;
  background: #fff;
  border: 1px solid #ddd7cb;
  border-radius: 14px;
  box-shadow: 0 24px 70px rgba(40, 34, 22, 0.22);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.us-drawer-head {
  padding: 18px 24px 16px;
  border-bottom: 1px solid #e7e3da;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
  margin: 0;
  text-align: left;
  font-weight: 400;
}
.us-drawer-title {
  font-size: 22px;
  line-height: 1.1;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.us-drawer-sub {
  font-size: 12.5px;
  color: #8b8477;
  margin-top: 3px;
}
.us-drawer-close {
  margin-left: auto;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #e7e3da;
  background: #fff;
  color: #6f6a60;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
}
.us-drawer-close:hover {
  background: #f6f4ef;
}
.us-drawer-body {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.us-drawer-foot {
  padding: 14px 24px;
  border-top: 1px solid #e7e3da;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  background: #fff;
}
.us-drawer-foot .us-spacer {
  flex-grow: 1;
}
.us-confirm {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #4a453c;
  flex-grow: 1;
}
.us-confirm b {
  font-weight: 600;
  color: #a8483e;
}

.us-section-title {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8b8477;
  margin: 0 0 10px;
}
.us-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.us-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}
.us-field.is-wide {
  grid-column: 1 / -1;
}
.us-field-label {
  font-size: 12px;
  font-weight: 600;
  color: #4a453c;
}
.us-field-hint {
  font-size: 11.5px;
  color: #a29b8d;
}
.us-input {
  height: 36px;
  border: 1px solid #e7e3da;
  border-radius: 8px;
  padding: 0 11px;
  font: 400 13.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  background: #fdfcfa;
  outline: none;
  width: 100%;
}
.us-input:focus {
  border-color: var(--rf-brand-lite);
  background: #fff;
}
.us-input:disabled {
  color: #8b8477;
  background: #f6f4ef;
}

/* business tabs inside the editor (group page) */
.us-biztabs {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.us-biztab {
  height: 30px;
  padding: 0 11px;
  border-radius: 20px;
  border: 1px solid #e7e3da;
  background: #fff;
  cursor: pointer;
  font: 600 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #4a453c;
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
.us-biztab.is-active {
  background: #191714;
  border-color: #191714;
  color: #fff;
}
.us-biztab .us-biztab-role {
  font-weight: 500;
  opacity: 0.7;
}
.us-biztab.is-new::after {
  content: "new";
  font-size: 10px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  opacity: 0.8;
}
.us-biztabs .us-select {
  height: 30px;
  font-size: 12px;
  border-radius: 20px;
}
.us-blocked-note {
  font-size: 12.5px;
  color: #8a3a31;
  background: #f7ebe9;
  border: 1px solid #ecd2ce;
  border-radius: 8px;
  padding: 9px 12px;
}
.us-row.is-blocked .us-avatar {
  opacity: 0.5;
}
.us-row.is-blocked .us-person-name {
  color: #8b8477;
}
.us-readonly-note {
  font-size: 12.5px;
  color: #8b8477;
  background: #fbf9f5;
  border: 1px solid #eee9df;
  border-radius: 8px;
  padding: 9px 12px;
  margin-bottom: 14px;
}

/* role cards */
.us-roles {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}
.us-role {
  border: 1px solid #e7e3da;
  border-radius: 10px;
  background: #fff;
  padding: 10px 11px;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}
.us-role:hover:not(:disabled) {
  background: #fdfcfa;
}
.us-role.is-active {
  border-color: var(--rf-brand);
  box-shadow: inset 0 0 0 1px var(--rf-brand);
  background: var(--rf-brand-wash);
}
.us-role:disabled {
  cursor: default;
  opacity: 0.6;
}
.us-role-name {
  font-size: 13px;
  font-weight: 600;
  color: #191714;
}
.us-role-help {
  font-size: 11px;
  color: #8b8477;
  line-height: 1.35;
}

/* ---------------- standalone (overview) chrome ---------------- */
.us-topbar-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* ---------------- group page boards ---------------- */
/* Owners on top, then one board per business. The boards column scrolls
   as a whole; the tables inside grow to their content. */
.us-boards {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 28px 22px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.us-boards .us-table {
  flex-grow: 0;
  flex-shrink: 0;
}
.us-boards .us-tbody {
  flex-grow: 0;
  overflow: visible;
}
.us-boards .us-group-head {
  position: static;
}
.us-board-head {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 52px;
  padding: 10px 18px;
  background: #fff;
  border-bottom: 1px solid #e7e3da;
}
.us-board-head i {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: currentColor;
  display: block;
}
.us-board-head.role-owner i {
  color: var(--rf-brand);
}
.us-board-title {
  font-size: 18px;
  font-weight: 500;
  color: #2c2820;
  line-height: 1.2;
}
.us-board-sub {
  font-size: 12px;
  color: #8b8477;
  padding-left: 4px;
}
.us-board-code {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--rf-brand);
  background: #f6f4ef;
  border: 1px solid #e7e3da;
  border-radius: 6px;
  padding: 2px 7px;
}
.us-biz-grid {
  display: grid;
  grid-template-columns: repeat(var(--us-boards, 2), minmax(0, 1fr));
  gap: 18px;
  align-items: start;
}
.us-biz-grid .us-col-actions {
  width: 80px;
}
.us-biz-grid .us-col-role {
  width: 120px;
}
.us-boards > .us-empty {
  padding: 40px 0;
}

@media (max-width: 1100px) {
  .us-biz-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .us-col-biz {
    width: 190px;
  }
  .us-col-date {
    display: none;
  }
  .us-roles {
    grid-template-columns: repeat(2, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/users-redesign.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB;;4CAE0C;EAC1C,0BAA0B;EAC1B,4DAA4D;EAC5D,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,6CAA6C;EAC7C,0BAA0B;AAC5B;AACA;;;EAGE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,+CAA+C;EAC/C,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;;AAEA,uDAAuD;AACvD;EACE,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,cAAc;EACd,qDAAqD;EACrD,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,8DAA8D;EAC9D,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gEAAgE;EAChE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oFAAoP;EACpP,8DAA8D;EAC9D,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,aAAa;AACf;AACA;EACE,kCAAkC;AACpC;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,8DAA8D;EAC9D,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,8DAA8D;EAC9D,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,6DAA6D;AAC7D;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4DAA4D;EAC5D,cAAc;AAChB;AACA;;;EAGE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gEAAgE;EAChE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,8DAA8D;EAC9D,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,mEAAmE;AACnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,wDAAwD;AACxD;yDACyD;AACzD;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* Users (redesign) — /users inside a business and /overview/users for the\n   whole group. Scoped under .us-page. Colours are written out rather than\n   taken from --rf-* so the same sheet renders identically inside the\n   AppShell (.rf-app) and on the standalone overview chrome (.overview-page). */\n\n.us-page {\n  flex-grow: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  /* .rf-content doesn't cap height — bound to the viewport minus the top\n     bar (64px) and the .rf-app gutter + border, so the table scrolls\n     internally and the toolbar stays put. */\n  height: calc(100vh - 76px);\n  font-family: \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  -webkit-font-smoothing: antialiased;\n}\n.us-page.is-standalone {\n  /* Under the 68px overview top bar instead. */\n  height: calc(100vh - 68px);\n}\n.us-page *,\n.us-page *::before,\n.us-page *::after {\n  box-sizing: border-box;\n  transition: none;\n}\n.us-serif {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-weight: 400;\n}\n.us-num {\n  font-variant-numeric: tabular-nums;\n}\n\n/* ---------------- header + toolbar ---------------- */\n.us-head {\n  padding: 22px 28px 0;\n  display: flex;\n  align-items: flex-end;\n  gap: 18px;\n  flex-shrink: 0;\n  /* App.css styles bare <header> globally — reset it */\n  margin: 0;\n  text-align: left;\n  font-weight: normal;\n}\n.us-head-text {\n  min-width: 0;\n  flex-grow: 1;\n}\n.us-title {\n  font-size: 24px;\n  line-height: 1.15;\n  margin: 0;\n  color: #191714;\n}\n.us-lede {\n  font-size: 13px;\n  color: #6f6a60;\n  margin: 4px 0 0;\n}\n.us-toolbar {\n  padding: 16px 28px 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n.us-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 34px;\n  padding: 0 12px;\n  border: 1px solid #e7e3da;\n  border-radius: 8px;\n  background: #fdfcfa;\n  min-width: 250px;\n  cursor: text;\n}\n.us-search:focus-within {\n  border-color: var(--rf-brand-lite);\n}\n.us-search-icon {\n  width: 13px;\n  height: 13px;\n  border: 1.5px solid #a29b8d;\n  border-radius: 50%;\n  display: block;\n  flex-shrink: 0;\n}\n.us-search input {\n  border: none;\n  background: none;\n  outline: none;\n  font: 400 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  width: 100%;\n}\n.us-search input::placeholder {\n  color: #a29b8d;\n}\n.us-segmented {\n  display: flex;\n  gap: 2px;\n  background: #eae6dd;\n  padding: 3px;\n  border-radius: 9px;\n}\n.us-segmented button {\n  border: none;\n  cursor: pointer;\n  padding: 6px 12px;\n  border-radius: 7px;\n  font: 600 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  background: transparent;\n  color: #7c766a;\n  white-space: nowrap;\n}\n.us-segmented button.is-active {\n  background: #fff;\n  color: #191714;\n  box-shadow: 0 1px 3px rgba(40, 34, 22, 0.14);\n}\n.us-select {\n  height: 34px;\n  padding: 0 32px 0 11px;\n  border: 1px solid #e7e3da;\n  border-radius: 8px;\n  background: #fff url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%23a29b8d' stroke-width='1.5'/%3E%3C/svg%3E\") no-repeat right 11px center;\n  font: 500 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #4a453c;\n  appearance: none;\n  -webkit-appearance: none;\n  cursor: pointer;\n  outline: none;\n}\n.us-select:focus {\n  border-color: var(--rf-brand-lite);\n}\n.us-spacer {\n  flex-grow: 1;\n}\n.us-btn {\n  cursor: pointer;\n  height: 34px;\n  border-radius: 8px;\n  font: 600 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  white-space: nowrap;\n}\n.us-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.us-btn-ghost {\n  padding: 0 14px;\n  border: 1px solid #e7e3da;\n  background: #fff;\n  color: #4a453c;\n}\n.us-btn-ghost:hover:not(:disabled) {\n  background: #f6f4ef;\n}\n.us-btn-primary {\n  padding: 0 16px;\n  border: none;\n  background: var(--rf-brand);\n  color: #fff;\n}\n.us-btn-primary:hover:not(:disabled) {\n  background: var(--rf-brand-hover);\n}\n.us-btn-danger {\n  padding: 0 14px;\n  border: 1px solid #e9cfcb;\n  background: #fff;\n  color: #a8483e;\n}\n.us-btn-danger:hover:not(:disabled) {\n  background: #fbefed;\n}\n.us-link {\n  background: none;\n  border: none;\n  padding: 0;\n  font: 600 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--rf-brand);\n  cursor: pointer;\n  white-space: nowrap;\n}\n.us-link:hover {\n  color: var(--rf-brand-lite);\n}\n.us-count {\n  font-size: 12.5px;\n  color: #8b8477;\n  white-space: nowrap;\n}\n\n/* ---------------- table ---------------- */\n.us-tablewrap {\n  flex-grow: 1;\n  min-height: 0;\n  padding: 0 28px 22px;\n  display: flex;\n}\n.us-table {\n  flex-grow: 1;\n  min-width: 0;\n  background: #fff;\n  border: 1px solid #e7e3da;\n  border-radius: 12px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.us-thead {\n  display: flex;\n  align-items: center;\n  height: 38px;\n  padding: 0 18px;\n  background: #faf8f3;\n  border-bottom: 1px solid #e7e3da;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #8b8477;\n  flex-shrink: 0;\n}\n.us-tbody {\n  flex-grow: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n.us-row {\n  display: flex;\n  align-items: center;\n  min-height: 60px;\n  padding: 10px 18px;\n  border-bottom: 1px solid #f0ece3;\n  background: #fff;\n  cursor: pointer;\n  width: 100%;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n  text-align: left;\n  font-family: inherit;\n  color: inherit;\n}\n.us-row:hover {\n  background: #fdfcfa;\n}\n.us-row.is-self {\n  background: #fbf9f5;\n}\n.us-group:last-child .us-row:last-child {\n  border-bottom: none;\n}\n\n/* group header: one per role, sticks while its rows scroll */\n.us-group-head {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 34px;\n  padding: 0 18px;\n  background: #f6f4ef;\n  border-bottom: 1px solid #e7e3da;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #4a453c;\n}\n.us-group-head i {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: currentColor;\n  display: block;\n}\n.us-group-head.role-owner i {\n  color: var(--rf-brand);\n}\n.us-group-head.role-admin i {\n  color: var(--rf-accent);\n}\n.us-group-head.role-staff i {\n  color: #7a5b7d;\n}\n.us-group-head.role-driver i {\n  color: #6b6f3f;\n}\n.us-group-count {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #8b8477;\n  background: #fff;\n  border: 1px solid #e7e3da;\n  border-radius: 20px;\n  padding: 1px 8px;\n}\n\n.us-col-person {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-right: 16px;\n}\n.us-col-biz {\n  width: 250px;\n  flex-shrink: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  padding-right: 16px;\n}\n.us-col-role {\n  width: 150px;\n  flex-shrink: 0;\n  padding-right: 12px;\n}\n.us-col-date {\n  width: 110px;\n  flex-shrink: 0;\n}\n.us-row .us-col-date {\n  font-size: 12.5px;\n  color: #6f6a60;\n}\n.us-col-actions {\n  width: 120px;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.us-col-actions .us-btn {\n  height: 30px;\n  padding: 0 11px;\n  font-size: 12px;\n}\n\n.us-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  letter-spacing: 0.02em;\n  overflow: hidden;\n}\n.us-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.us-avatar.is-lg {\n  width: 48px;\n  height: 48px;\n  font-size: 16px;\n}\n.us-person {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.us-person-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #191714;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.us-person-sub {\n  font-size: 12px;\n  color: #8b8477;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.us-person-email {\n  margin-left: 8px;\n  padding-left: 8px;\n  border-left: 1px solid #ddd7cb;\n}\n\n.us-you {\n  display: inline-block;\n  margin-left: 6px;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--rf-brand);\n  background: var(--rf-brand-tint);\n  padding: 1px 6px;\n  border-radius: 20px;\n  vertical-align: 1px;\n}\n\n/* role pill: the four roles each get a tone */\n.us-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 24px;\n  padding: 0 9px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  background: #f6f4ef;\n  color: #4a453c;\n}\n.us-pill i {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n  display: block;\n}\n.us-pill.role-owner {\n  background: var(--rf-brand-tint);\n  color: var(--rf-brand);\n}\n.us-pill.role-admin {\n  background: #e9f0ef;\n  color: var(--rf-accent);\n}\n.us-pill.role-staff {\n  background: #f1eef2;\n  color: #7a5b7d;\n}\n.us-pill.role-driver {\n  background: #eeefe3;\n  color: #6b6f3f;\n}\n.us-pill.is-readonly {\n  opacity: 0.7;\n}\n.us-pill-code {\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n.us-pill-sep {\n  opacity: 0.5;\n}\n\n.us-inactive {\n  display: inline-block;\n  margin-left: 6px;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #a8483e;\n  background: #f7ebe9;\n  padding: 1px 6px;\n  border-radius: 20px;\n}\n\n/* empty / error / loading */\n.us-empty {\n  padding: 48px 0;\n  text-align: center;\n  color: #a29b8d;\n  font-size: 13px;\n}\n.us-empty b {\n  display: block;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-weight: 400;\n  font-size: 20px;\n  color: #191714;\n  margin-bottom: 6px;\n}\n.us-error {\n  margin: 0 28px 22px;\n  background: #fbf9f5;\n  border: 1px solid #eee9df;\n  border-radius: 10px;\n  padding: 14px 16px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  font-size: 13px;\n  color: #4a453c;\n}\n.us-error b {\n  font-weight: 600;\n  color: #191714;\n}\n.us-skel {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 60px;\n  padding: 10px 18px;\n  border-bottom: 1px solid #f0ece3;\n}\n.us-skel i {\n  display: block;\n  height: 12px;\n  border-radius: 6px;\n  background: #f0ece3;\n}\n.us-skel .us-skel-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n}\n\n/* ---------------- editor modal (centred) ---------------- */\n.us-drawer-wrap {\n  position: fixed;\n  inset: 0;\n  z-index: 80;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  font-family: \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.us-drawer-wrap *,\n.us-drawer-wrap *::before,\n.us-drawer-wrap *::after {\n  box-sizing: border-box;\n  transition: none;\n}\n.us-scrim {\n  position: absolute;\n  inset: 0;\n  background: rgba(25, 23, 20, 0.36);\n}\n.us-drawer {\n  position: relative;\n  width: 620px;\n  max-width: 100%;\n  max-height: 100%;\n  background: #fff;\n  border: 1px solid #ddd7cb;\n  border-radius: 14px;\n  box-shadow: 0 24px 70px rgba(40, 34, 22, 0.22);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.us-drawer-head {\n  padding: 18px 24px 16px;\n  border-bottom: 1px solid #e7e3da;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-shrink: 0;\n  margin: 0;\n  text-align: left;\n  font-weight: 400;\n}\n.us-drawer-title {\n  font-size: 22px;\n  line-height: 1.1;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.us-drawer-sub {\n  font-size: 12.5px;\n  color: #8b8477;\n  margin-top: 3px;\n}\n.us-drawer-close {\n  margin-left: auto;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid #e7e3da;\n  background: #fff;\n  color: #6f6a60;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.us-drawer-close:hover {\n  background: #f6f4ef;\n}\n.us-drawer-body {\n  flex-grow: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 20px 24px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n}\n.us-drawer-foot {\n  padding: 14px 24px;\n  border-top: 1px solid #e7e3da;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  background: #fff;\n}\n.us-drawer-foot .us-spacer {\n  flex-grow: 1;\n}\n.us-confirm {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  color: #4a453c;\n  flex-grow: 1;\n}\n.us-confirm b {\n  font-weight: 600;\n  color: #a8483e;\n}\n\n.us-section-title {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #8b8477;\n  margin: 0 0 10px;\n}\n.us-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n.us-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n}\n.us-field.is-wide {\n  grid-column: 1 / -1;\n}\n.us-field-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #4a453c;\n}\n.us-field-hint {\n  font-size: 11.5px;\n  color: #a29b8d;\n}\n.us-input {\n  height: 36px;\n  border: 1px solid #e7e3da;\n  border-radius: 8px;\n  padding: 0 11px;\n  font: 400 13.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  background: #fdfcfa;\n  outline: none;\n  width: 100%;\n}\n.us-input:focus {\n  border-color: var(--rf-brand-lite);\n  background: #fff;\n}\n.us-input:disabled {\n  color: #8b8477;\n  background: #f6f4ef;\n}\n\n/* business tabs inside the editor (group page) */\n.us-biztabs {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-bottom: 14px;\n}\n.us-biztab {\n  height: 30px;\n  padding: 0 11px;\n  border-radius: 20px;\n  border: 1px solid #e7e3da;\n  background: #fff;\n  cursor: pointer;\n  font: 600 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #4a453c;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n.us-biztab.is-active {\n  background: #191714;\n  border-color: #191714;\n  color: #fff;\n}\n.us-biztab .us-biztab-role {\n  font-weight: 500;\n  opacity: 0.7;\n}\n.us-biztab.is-new::after {\n  content: \"new\";\n  font-size: 10px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  opacity: 0.8;\n}\n.us-biztabs .us-select {\n  height: 30px;\n  font-size: 12px;\n  border-radius: 20px;\n}\n.us-blocked-note {\n  font-size: 12.5px;\n  color: #8a3a31;\n  background: #f7ebe9;\n  border: 1px solid #ecd2ce;\n  border-radius: 8px;\n  padding: 9px 12px;\n}\n.us-row.is-blocked .us-avatar {\n  opacity: 0.5;\n}\n.us-row.is-blocked .us-person-name {\n  color: #8b8477;\n}\n.us-readonly-note {\n  font-size: 12.5px;\n  color: #8b8477;\n  background: #fbf9f5;\n  border: 1px solid #eee9df;\n  border-radius: 8px;\n  padding: 9px 12px;\n  margin-bottom: 14px;\n}\n\n/* role cards */\n.us-roles {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n}\n.us-role {\n  border: 1px solid #e7e3da;\n  border-radius: 10px;\n  background: #fff;\n  padding: 10px 11px;\n  text-align: left;\n  cursor: pointer;\n  font-family: inherit;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n.us-role:hover:not(:disabled) {\n  background: #fdfcfa;\n}\n.us-role.is-active {\n  border-color: var(--rf-brand);\n  box-shadow: inset 0 0 0 1px var(--rf-brand);\n  background: var(--rf-brand-wash);\n}\n.us-role:disabled {\n  cursor: default;\n  opacity: 0.6;\n}\n.us-role-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n}\n.us-role-help {\n  font-size: 11px;\n  color: #8b8477;\n  line-height: 1.35;\n}\n\n/* ---------------- standalone (overview) chrome ---------------- */\n.us-topbar-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* ---------------- group page boards ---------------- */\n/* Owners on top, then one board per business. The boards column scrolls\n   as a whole; the tables inside grow to their content. */\n.us-boards {\n  flex-grow: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0 28px 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n.us-boards .us-table {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.us-boards .us-tbody {\n  flex-grow: 0;\n  overflow: visible;\n}\n.us-boards .us-group-head {\n  position: static;\n}\n.us-board-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 52px;\n  padding: 10px 18px;\n  background: #fff;\n  border-bottom: 1px solid #e7e3da;\n}\n.us-board-head i {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: currentColor;\n  display: block;\n}\n.us-board-head.role-owner i {\n  color: var(--rf-brand);\n}\n.us-board-title {\n  font-size: 18px;\n  font-weight: 500;\n  color: #2c2820;\n  line-height: 1.2;\n}\n.us-board-sub {\n  font-size: 12px;\n  color: #8b8477;\n  padding-left: 4px;\n}\n.us-board-code {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--rf-brand);\n  background: #f6f4ef;\n  border: 1px solid #e7e3da;\n  border-radius: 6px;\n  padding: 2px 7px;\n}\n.us-biz-grid {\n  display: grid;\n  grid-template-columns: repeat(var(--us-boards, 2), minmax(0, 1fr));\n  gap: 18px;\n  align-items: start;\n}\n.us-biz-grid .us-col-actions {\n  width: 80px;\n}\n.us-biz-grid .us-col-role {\n  width: 120px;\n}\n.us-boards > .us-empty {\n  padding: 40px 0;\n}\n\n@media (max-width: 1100px) {\n  .us-biz-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .us-col-biz {\n    width: 190px;\n  }\n  .us-col-date {\n    display: none;\n  }\n  .us-roles {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
